// extracted by mini-css-extract-plugin
export default {"container":"introduce_container__VFmGr","text":"introduce_text__nm4sA","icon":"introduce_icon__kMhZ1","album":"introduce_album__V5XQS"};